import React from 'react'
import style from '../styles/auth_reg.module.scss'
import BaseLayout from './BaseLayout'
import BackLink from '@/components/BackLink'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { asideLogo, okIcon, vkIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { Link } from 'react-router-dom'

const AuthRegLayout = ({ children }): React.ReactElement => {
  const page = usePage()

  const { config } = page?.init_state?.global
  const { object } = page?.init_state

  return (
    <BaseLayout>
      <div className={style.auth}>
        <div className={style.auth_wrap}>
          <header className={style.auth__logo_wrap}>
            <BackLink title='Назад' href='/' className={style.auth__back} />
            <Link to={config.home_url} className={style.auth__logo_link}>
              <img
                src={asideLogo}
                width='330px'
                height='152px'
                alt='Логотип'
                className={style.auth__logo}
              />
            </Link>
          </header>
          <main className={style.content}>
            <Title type='h1' hidden>
              {object.title}
            </Title>

            {children}
          </main>

          <footer className={style.bottom}>
            <a href='mailto:obuchenie@fondrt.ru' className={style.bottom__mail}>
              obuchenie@fondrt.ru
            </a>
            <div className={style.bottom_flex}>
              <ul className={style.bottom_social}>
                <li className={style.bottom_social__item}>
                  <a
                    href={config.ok_link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={style.bottom_social__link}
                  >
                    <GxIcon
                      src={okIcon}
                      className={style.bottom_social__icon}
                    />
                  </a>
                </li>
                <li className={style.bottom_social__item}>
                  <a
                    href={config.vk_link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={style.bottom_social__link}
                  >
                    <GxIcon
                      src={vkIcon}
                      className={style.bottom_social__icon}
                    />
                  </a>
                </li>
              </ul>
              <Link to={config.privacy_policy} className={style.bottom__policy}>
                Политика конфиденциальности
              </Link>
            </div>
          </footer>
        </div>
      </div>
    </BaseLayout>
  )
}

export default AuthRegLayout
